import { useTranslation } from 'next-i18next'
import React from 'react'

import Layout from '@src/pages/layout'
import SomethingWentWrongPage from '@src/quince-site-common/src/organisms/appLayout/molecules/errorBoundary/somethingWentWrong/ErrorPage'
import { isProd } from '@src/quince-site-common/src/utils/isEnv'
import { ServerSideProps } from '@src/utils/page-type.utils'

export const NotFoundErrorPage = ({
  props,
  showDebugInfo = !isProd,
}: {
  props: ServerSideProps
  showDebugInfo?: boolean
}) => {
  const { t } = useTranslation('common')

  return (
    <SomethingWentWrongPage showHeader>
      {showDebugInfo ? (
        <div>
          <h1>{t('should_render_404_page')}</h1>
          <pre
            style={{
              overflow: 'scroll',
            }}
          >
            {JSON.stringify(props, null, 2)}
          </pre>
        </div>
      ) : null}
    </SomethingWentWrongPage>
  )
}

export const CaughtErrorPage = ({
  error,
  props,
  showDebugInfo = !isProd,
}: {
  error: unknown
  props: ServerSideProps
  showDebugInfo?: boolean
}) => {
  const { t } = useTranslation('common')

  return (
    <SomethingWentWrongPage showHeader>
      {showDebugInfo ? (
        <div>
          <h1>{t('should_render_400_page')}</h1>
          <pre>{JSON.stringify(error, null, 2)}</pre>
          <pre>{JSON.stringify(props, null, 2)}</pre>
        </div>
      ) : null}
    </SomethingWentWrongPage>
  )
}

export const LayoutErrorPage = ({ props }: { props: ServerSideProps }) => {
  if (props.type != '_page') {
    return null
  }

  return (
    <Layout {...props}>
      <SomethingWentWrongPage showHeader={false} />
    </Layout>
  )
}
